// Brand logos imports
import google from "../assets/google.png";
import slack from "../assets/slack.png";
import atlassian from "../assets/atlassian.png";
import dropbox from "../assets/dropbox.png";
import shopify from "../assets/shopify.png";

// Blog images imports
import blog01 from "../assets/blog01.png";
import blog02 from "../assets/blog02.png";
import blog03 from "../assets/blog03.png";
import blog04 from "../assets/blog04.png";
import blog05 from "../assets/blog05.png";

// Other assets
import logo from "../assets/logo.svg";
import ai from "../assets/ai.png";
import people from "../assets/people.png";
import possibility from "../assets/possibility.png";

// Export brand logos
export const brandLogos = {
  google,
  slack,
  atlassian,
  dropbox,
  shopify,
};

// Export blog images
export const blogImages = {
  blog01,
  blog02,
  blog03,
  blog04,
  blog05,
};

// Export other assets
export const assets = {
  logo,
  ai,
  people,
  possibility,
};

// Features data
export const featuresData = [
  {
    title: "Advanced Natural Language Processing",
    text: "Experience cutting-edge NLP capabilities that understand context, nuance, and intent. GPT-3 processes and generates human-like text with unprecedented accuracy, making it perfect for content creation, translation, and communication.",
  },
  {
    title: "Seamless Integration & API Access",
    text: "Integrate GPT-3 effortlessly into your existing applications with our robust API. Build powerful AI features quickly with comprehensive documentation, developer tools, and dedicated support to accelerate your development process.",
  },
  {
    title: "Scalable & Enterprise-Ready",
    text: "Deploy AI solutions that scale with your business needs. From startups to enterprise-level applications, GPT-3 provides reliable performance, high availability, and the flexibility to handle projects of any size.",
  },
  {
    title: "Continuous Learning & Updates",
    text: "Stay ahead with regular model updates and improvements. Our team continuously enhances GPT-3's capabilities, ensuring you always have access to the latest AI advancements and best-in-class performance.",
  },
];

// Blog posts data
export const blogPosts = [
  {
    imgUrl: blog01,
    date: "Dec 15, 2024",
    text: "GPT-3 and OpenAI: The Future of Artificial Intelligence. Let us explore how it's transforming industries.",
  },
  {
    imgUrl: blog02,
    date: "Dec 10, 2024",
    text: "Revolutionizing Content Creation: How GPT-3 is Changing the Way We Write and Create.",
  },
  {
    imgUrl: blog03,
    date: "Dec 5, 2024",
    text: "Building Intelligent Chatbots: A Complete Guide to Implementing GPT-3 in Your Applications.",
  },
  {
    imgUrl: blog04,
    date: "Nov 28, 2024",
    text: "The Power of Language Models: Understanding GPT-3's Impact on Business and Technology.",
  },
  {
    imgUrl: blog05,
    date: "Nov 20, 2024",
    text: "From Code to Conversation: How Developers Are Leveraging GPT-3 for Innovation.",
  },
];

// Navigation links
export const navLinks = [
  { name: "Home", href: "#home" },
  { name: "What is GPT3?", href: "#wgpt3" },
  { name: "Open AI", href: "#possibility" },
  { name: "Case Studies", href: "#features" },
  { name: "Library", href: "#blog" },
];


